module.exports = __webpack_public_path__ + "img/scrmNum5.31c4831d.png";